import React from "react";
import "./css/style.scss";
import IconRenderer from "../../../components/IconRenderer";
import WidgetTile from "../../../components/widgetTile";

const WidgetMyReports = () => {
  return (
    <WidgetTile
      title={"My Reports"}
     
      bodyContent={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "34px",
            alignItems: "flex-start",
            fontFamily: "var(--font-family)",
          }}
        >
          <span
            style={{
              color: "var(--line-chart-ticks-color)",
              fontSize: "12px",
            }}
          >
            Recommended and Pinned
          </span>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            {/* P & L Reporting */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                alignItems: "flex-start",
                padding: "8px",
                cursor: "pointer",
              }}
              onClick={() =>
                window.open(
                  "https://app.powerbi.com/groups/me/apps/0fb3b7e5-2016-4aba-b6ae-b5b3c8a4937d/reports/2ee2b593-4f2d-46c8-9ba9-5821a9878c96/5de98231ca6dc3995210?ctid=e0793d39-0939-496d-b129-198edd916feb&experience=power-bi",
                  "_blank"
                )
              }
            >
              <IconRenderer keyword={"widget_report"} />
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "var(--card-primary-color)",
                }}
              >
                P & L Reporting
              </span>
            </div>

            {/* Revenue Analysis */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                alignItems: "flex-start",
                padding: "8px",
              }}
            >
              <IconRenderer keyword={"widget_report"} />
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "var(--card-primary-color)",
                }}
              >
                Revenue Analysis
              </span>
            </div>

            {/* Expense Analysis */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                alignItems: "flex-start",
                padding: "8px",
                cursor: "pointer",
              }}
              onClick={() =>
                window.open(
                  "https://app.powerbi.com/groups/me/apps/0fb3b7e5-2016-4aba-b6ae-b5b3c8a4937d/reports/2ee2b593-4f2d-46c8-9ba9-5821a9878c96/5de98231ca6dc3995210?ctid=e0793d39-0939-496d-b129-198edd916feb&experience=power-bi",
                  "_blank"
                )
              }
            >
              <IconRenderer keyword={"widget_report"} />
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "var(--card-primary-color)",
                }}
              >
                Expense Analysis
              </span>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default WidgetMyReports;
